import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const loginState = atom({
  key: "VASSLoginNew",
  default: {
    isLogin: false,
    isUserIdStored: false,
    company: "",
    userId: "",
    branchName: "",
    branchCode: "",
    localIP: "",
    saId: "",
    accountId: "",
    camUsable: "",
    nvrUsable: "0",
    isAdmin: false,
    camStatus: "",
    // KPC는 한국 날짜가 바뀌면 반드시 다시 로그인하도록 로그인 성공 날짜를 저장한다.
    kpcLoginDate: "",
  },
  effects_UNSTABLE: [persistAtom],
});
